export default "__VITE_ASSET__B9B2UF9a__"